import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {denim, taupe, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    backgroundColor: white,
    height: '100vh' as any,
    flex: 1,
    minHeight: 0 as const,
    overflow: 'hidden' as const,
  },
  title: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleWrapper: {
    flex: 1,
    minWidth: 0,
    justifyContent: 'center',
    paddingHorizontal: 4,
  },
  headerText: {
    flexShrink: 1,
    includeFontPadding: false,
  },
  profileTitle: {
    alignSelf: 'center',
  },
  closeButton: {
    minWidth: 44,
    minHeight: 44,
    padding: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  actions: {
    height: 32,
    flexDirection: 'row',
    marginVertical: 16,
    alignItems: 'center',
  },
  actionIcon: {
    fontSize: 26,
    color: taupe,
  },
  iconWrapperWeb: {
    cursor: 'pointer' as any,
  },
  actionFiller: {
    flex: 1,
  },
  actionButton: {
    paddingHorizontal: 0,
  },
  actionText: {
    textAlign: 'center',
    includeFontPadding: false,
  },
  editButtonText: {
    color: denim,
    fontWeight: '600',
  },

  profileTitleWeb: {
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto' as const,
    minWidth: 1,
    paddingHorizontal: 0,
    marginLeft: 4,
    alignSelf: 'center' as const,
  },

  backButtonWeb: {
    minWidth: 28,
    minHeight: 28,
    padding: 0,
    marginRight: 8,
  },

  backHeaderActionsWeb: {
    marginTop: 0,
  },
});
